__turbopack_context__.v({
  "block__alert": "styles-module-scss-module__HkG2YG__block__alert",
  "block__checkbox": "styles-module-scss-module__HkG2YG__block__checkbox",
  "block__checkbox-checked": "styles-module-scss-module__HkG2YG__block__checkbox-checked",
  "block__checkbox-unchecked": "styles-module-scss-module__HkG2YG__block__checkbox-unchecked",
  "block__colored": "styles-module-scss-module__HkG2YG__block__colored",
  "block__colored-info": "styles-module-scss-module__HkG2YG__block__colored-info",
  "block__colored-primary": "styles-module-scss-module__HkG2YG__block__colored-primary",
  "block__colored-secondary": "styles-module-scss-module__HkG2YG__block__colored-secondary",
  "block__colored-success": "styles-module-scss-module__HkG2YG__block__colored-success",
  "block__columns": "styles-module-scss-module__HkG2YG__block__columns",
  "block__columns-2": "styles-module-scss-module__HkG2YG__block__columns-2",
  "block__columns-3": "styles-module-scss-module__HkG2YG__block__columns-3",
  "block__divider": "styles-module-scss-module__HkG2YG__block__divider",
  "block__embed": "styles-module-scss-module__HkG2YG__block__embed",
  "block__image": "styles-module-scss-module__HkG2YG__block__image",
  "block__image-link": "styles-module-scss-module__HkG2YG__block__image-link",
  "block__link": "styles-module-scss-module__HkG2YG__block__link",
  "block__ol": "styles-module-scss-module__HkG2YG__block__ol",
  "block__paragraph": "styles-module-scss-module__HkG2YG__block__paragraph",
  "block__table": "styles-module-scss-module__HkG2YG__block__table",
  "block__table-headings": "styles-module-scss-module__HkG2YG__block__table-headings",
  "block__title": "styles-module-scss-module__HkG2YG__block__title",
  "block__title-2": "styles-module-scss-module__HkG2YG__block__title-2",
  "block__title-3": "styles-module-scss-module__HkG2YG__block__title-3",
  "block__title-4": "styles-module-scss-module__HkG2YG__block__title-4",
  "block__title-5": "styles-module-scss-module__HkG2YG__block__title-5",
  "block__ul": "styles-module-scss-module__HkG2YG__block__ul",
});
